export const PLAN_MANAGEMENT_V3 = 'plans-v3'
